














import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import AudienceListingResourceList from '@superComponents/AudienceListing/AudienceListingResourceList'
import CsvExportResourceTriggerModal from '@triggers/Utils/CsvExportResourceTriggerModal'

settings =
  name: 'AudienceListingList'

  resources:
    audience_listings:
      resourceName: 'audience_listings'
      slug: 'audience_listings'
      infinityScroll: true

  vue:
    components: {
      SuperContainerView,
      AudienceListingResourceList,
      CsvExportResourceTriggerModal,
    }

    data: ->
      bulkActionResultItems: []

    computed:
      actionsForResourceList: ->
        fetchResource: @fetchResource
        csvExportResourceTrigger: @csvExportResourceTrigger

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity state, resourceKey, data, options

      csvExportResourceTrigger: (payloadOptions) ->
        @$refs.csvExportResourceTrigger.fire @exportCsvParams('audience_listings', payloadOptions)
      onAudienceListingsCsvExport: ->
        @$refs.csvExportResourceTrigger.close()
      onAudienceListingsCsvExportError: -> @showError 'Failed to export csv'

export default VueOptions.vue settings
